module.exports = __webpack_public_path__ + "static/media/tractorPlow_green.43aa5343.svg";